<template>
  <div>
    <section>
      <div class="w-100 fixed-bottom margin-50">
        <div v-if="selectedProducts.length > 0" class="z-9999 d-flex flex-column justify-content-end align-items-center">
          <div v-if="showPricePanel" class="no-margin w-889 action-panel expanded">
            <div class="w-880 no-margin action-panel d-flex align-items-start">
              <form @submit.prevent="saveAll()" class="w-100">
                <div class="w-100 title-button-mob d-flex justify-content-between align-items-center border-b">
                  <div class="d-flex align-items-center gap-8">
                    <h6 class="mb-0 text-start ws-nowrap">Porcentagem</h6>
                    <hr class="d-none d-md-block border-t" />
                    <div class="w-100 d-flex justify-content-end align-items-center">
                      <div class="p-8 d-flex align-items-center gap-8 bg-gray-percent transition-all duration-300">
                        <div class="d-flex align-items-center gap-8">
                          <div class="transition-transform duration-300 transform cursor-pointer" @click="toggleIcon">
                            <img
                              v-if="!isUp"
                              :src="require('@/assets/images/arrow_drop_down.svg')"
                              class="icon-up-down transition-all duration-300"
                              alt="Expandir"
                            />
                            <img
                              v-else-if="isUp"
                              :src="require('@/assets/images/arrow_drop_up.svg')"
                              class="icon-up-down transition-all duration-300"
                              alt="Recolher"
                            />
                          </div>
                          <transition name="slide-fade">
                            <div class="d-flex input-gap border-b-percent">
                              <span class="input-group-text">%</span>
                              <input
                                type="number"
                                :value="adjustmentValue === 0 ? '' : adjustmentValue"
                                class="input-group input-group-text input-new-price"
                                min="0"
                                max="100"
                                style="cursor: default"
                                @input="handleAdjustmentInput($event)"
                                @blur="handleAdjustmentBlur"
                              />
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-8">
                    <button @click="openReturnOriginalPriceModal(selectedProducts)" type="button" class="btn actions-btn d-flex justify-content-center align-items-center mobile-responsive-limpar-filtro gap-8 text-black">
                      Preço Original
                    </button>
                    <button type="submit" class="button-w-100 btn btn-success px-32">
                      Salvar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div v-if="showLinkCategoryPanel" class="w-889 no-margin action-panel expanded">
            <div class="w-880 no-margin action-panel d-flex align-items-start">
              <form @submit.prevent="saveAll()" class="w-100">
                <div class="w-100 title-button-mob d-flex justify-content-between align-items-center border-b">
                  <div class="d-flex align-items-center gap-8">
                    <h6 class="mb-0 text-start ws-nowrap">Categorias</h6>
                    <hr class="d-none d-md-block border-t" />
                    <div class="w-100 d-flex justify-content-end align-items-center">
                    <div class="p-8 d-flex align-items-center gap-8 transition-all">
                      <div class="d-flex align-items-center gap-8">
                        <transition name="slide-fade">
                          <div class="d-flex input-gap">
                            <select
                              class="form-control"
                              v-model="selectedGlobalCategory"
                            >
                              <option disabled selected value="">Vincular categorias</option>
                              <option
                                v-for="category in categories"
                                :key="category.id"
                                :value="category.id"
                              >
                                {{ category.name }}
                              </option>
                            </select>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                  </div>
                  <button type="submit" class="button-w-100 btn btn-success px-32">
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div v-if="showLinkMaterialPanel" class="w-889 no-margin action-panel expanded">
            <div class="w-880 no-margin action-panel d-flex align-items-start">
              <form @submit.prevent="saveAll()" class="w-100">
                <div class="w-100 title-button-mob d-flex justify-content-between align-items-center border-b">
                  <div class="d-flex align-items-center gap-8">
                    <h6 class="mb-0 text-start ws-nowrap">Materiais</h6>
                    <hr class="d-none d-md-block border-t" />
                    <div class="w-100 d-flex justify-content-end align-items-center">
                    <div class="p-8 d-flex align-items-center gap-8 transition-all">
                      <div class="d-flex align-items-center gap-8">
                        <transition name="slide-fade">
                          <div class="d-flex input-gap">
                            <select
                              class="form-control"
                              v-model="selectedGlobalMaterial"
                            >
                              <option disabled selected value="">Vincular materiais</option>
                              <option
                                v-for="material in materials"
                                :key="material.id"
                                :value="material.id"
                              >
                                {{ material.description }}
                              </option>
                            </select>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                  </div>
                  <button type="submit" class="button-w-100 btn btn-success px-32">
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div v-if="showLinkColorPanel" class="w-889 no-margin action-panel expanded">
            <div class="w-880 no-margin action-panel d-flex align-items-start">
              <form @submit.prevent="saveAll()" class="w-100">
                <div class="w-100 title-button-mob d-flex justify-content-between align-items-center border-b">
                  <div class="d-flex align-items-center gap-8">
                    <h6 class="mb-0 text-start ws-nowrap">Cores</h6>
                    <hr class="d-none d-md-block border-t" />
                    <div class="w-100 d-flex justify-content-end align-items-center">
                    <div class="p-8 d-flex align-items-center gap-8 transition-all">
                      <div class="d-flex align-items-center gap-8">
                        <transition name="slide-fade">
                          <div class="d-flex input-gap">
                            <select
                              class="form-control"
                              v-model="selectedGlobalColor"
                            >
                              <option disabled selected value="">Vincular cor</option>
                              <option
                                v-for="color in colors"
                                :key="color.id"
                                :value="color.id"
                              >
                                {{ color.description }}
                              </option>
                            </select>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                  </div>
                  <button type="submit" class="button-w-100 btn btn-success px-32">
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            class="no-margin w-889 action-panel position-relative z-9999"
            :class="{ 'no-border-radius-top': showPricePanel || showLinkCategoryPanel }"
          >
            <div class="action-panel-content">
              <div class="actions d-flex-column-center">
                <div class="d-flex justify-content-center align-items-center gap-16 gap-none">
                  <button @click="closePopupAndClearSelection" class="actions-btn d-flex justify-content-center align-items-center">
                    <img :src="require('@/assets/images/icon_close-x.svg')" alt="Ícone de Fechar">
                  </button>
                  <div class="w-100 d-flex column-gap-4 text-center">
                    <div class="mw-20">
                      <span>{{ selectedProducts.length }}</span>
                    </div>
                    <p class="no-margin text-nowrap">itens selecionados</p>
                  </div>
                </div>
                <hr class="d-none d-md-block border-t" />
                <div class="w-100 d-flex-column-between">
                  <div class="flex-column-new">
                    <button @click="togglePricePanel" class="actions-btn d-flex justify-content-center align-items-center gap-8">
                      <img :src="require('@/assets/images/icon-money.svg')" alt="Ícone de Alterar Preço">
                      <p class="no-margin text-black">Alterar Preço</p>
                    </button>
                    <button @click="toggleLinkCategoryPanel" class="actions-btn d-flex justify-content-center align-items-center gap-8">
                      <img :src="require('@/assets/images/icon-category.svg')" alt="Ícone de Lixeira">
                      <p class="no-margin text-black">Categoria</p>
                    </button>
                    <button @click="toggleLinkMaterialPanel" class="actions-btn d-flex justify-content-center align-items-center gap-8">
                      <img :src="require('@/assets/images/icon-category.svg')" alt="Ícone de Material">
                      <p class="no-margin text-black">Material</p>
                    </button>
                    <button @click="toggleLinkColorPanel" class="actions-btn d-flex justify-content-center align-items-center gap-8">
                      <img :src="require('@/assets/images/icon-category.svg')" alt="Ícone de Cor">
                      <p class="no-margin text-black">Cor</p>
                    </button>
                  </div>
                </div>
              </div>
              <hr class="d-none d-md-block border-t" />
              <div class="actions d-none d-md-flex justify-content-center align-items-end text-center">
                <button @click="openDeleteModal(selectedProducts)" class="actions-btn d-flex justify-content-center align-items-center gap-8">
                  <img :src="require('@/assets/images/trash-icon.svg')" alt="Ícone de Lixeira">
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="products no-overflow">
        <div class="row">
          <div class="col">
            <div class="mb-20 d-flex-column">
              <div class="w-fit">
                <h1 class="fw-600 fs-24 mb-0 w-fit">Produtos</h1>
              </div>
              <div class="col-md-4 w-fit">
                <div class="input-search">
                    <i class="fas fa-search input-icon"></i>
                    <input @keyup.enter="applyFilters" type="text" v-model="filters.name" placeholder="Buscar Produto" class="form-control-input pr-35">
                </div>
              </div>
              <div class="w-fit d-flex align-items-center text-right text-end gap-16">
                <div @click="openFilterModal()" class="icon-filter">
                  <img :src="require('@/assets/images/icon_filter.svg')" alt="Ícone de Filtro">
                </div>
                <router-link class="btn btn-blue text-nowrap w-fit btn-border-4" to="/products/create">
                  <img :src="require('@/assets/images/icon_plus.svg')" alt="Ícone de Criar Produto">
                </router-link>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered table-hover">
                <thead>
                   <tr class="text-center nowrap">
                    <th>
                      <input type="checkbox" @change="toggleSelectAll" v-model="selectAll" ref="selectAllCheckbox" class="checkbox-wh cursor-pointer" />
                    </th>
                    <th>#</th>
                    <th @click="sortTable('status')" class="cursor-pointer">Status <span v-if="sortBy === 'status'">{{ sortOrder === 'asc' ? '🔼' : '🔽' }}</span></th>
                    <th></th>
                    <th @click="sortTable('title')" class="cursor-pointer">Nome <span v-if="sortBy === 'title'">{{ sortOrder === 'asc' ? '🔼' : '🔽' }}</span></th>
                    <th @click="sortTable('price')" class="cursor-pointer">Preço de Venda <span v-if="sortBy === 'price'">{{ sortOrder === 'asc' ? '🔼' : '🔽' }}</span></th>
                    <th @click="sortTable('stock_quantity')" class="cursor-pointer">Quantidade <span v-if="sortBy === 'stock_quantity'">{{ sortOrder === 'asc' ? '🔼' : '🔽' }}</span></th>
                    <th @click="sortTable('variants_count')" class="cursor-pointer">Variações <span v-if="sortBy === 'variants_count'">{{ sortOrder === 'asc' ? '🔼' : '🔽' }}</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in sortedProducts" :key="product.id" class="text-center c-black">
                    <td class="align-middle vertical-none">
                      <input type="checkbox" @change="handleCheckboxChange" v-model="selectedProducts" :value="product.id" class="checkbox-wh cursor-pointer">
                    </td>
                    <td class="align-middle vertical-none">
                      <router-link :to="'./products/' + product.id" class="btn btn-link c-black body-table">
                        {{ product.id }}
                      </router-link>
                    </td>
                    <td class="align-middle vertical-none">
                      <router-link :to="'./products/' + product.id" class="btn btn-link c-black body-table">
                        <div :class="parseInt(product.status, 10) === 1 ? 'status-active' : 'status-inactive'" class="rounded-circle"> </div>
                      </router-link>
                    </td>
                    <td class="align-middle vertical-none">
                      <router-link :to="'./products/' + product.id">
                        <img :src="product.image_thumbnail ? product.image_thumbnail : '/img/no_product.png'" class="w-image-40 rounded-circle border" alt="" height="40">
                      </router-link>
                    </td>
                    <td class="align-middle vertical-none">
                      <router-link :to="'./products/' + product.id" class="btn btn-link c-black body-table">
                        {{ product.title }}
                      </router-link>
                    </td>
                    <td class="align-middle vertical-none">{{ product.saleprice | money }}</td>
                    <td class="align-middle vertical-none">{{ product.variants_sum_quantity ? product.variants_sum_quantity : product.stock_quantity }}</td>
                    <td class="align-middle vertical-none">{{ product.variants_count }}</td>
                    <td class="px-0">
                      <button class="btn mx-4" @click="openDeleteModal(product.id)">
                        <img :src="require('@/assets/images/trash-icon.svg')" alt="Ícone de Lixeira">
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <PaginateComponent :source="pagination" @navigate="navigate"/>
          </div>
        </div>
        <LoadingComponent :loading="loading" />

        <!-- Modal excluir produto -->
        <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModal" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row text-white">
                  <div class="col-12 d-flex justify-content-end mb-3">
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="col-8 pb-2 pt-1 pl-3">
                    <label class="form-control-label h4">Deseja excluir o produto?</label>
                  </div>
                  <div class="col-4 text-right">
                    <button type="button" class="btn btn-outline-danger" @click="confirmDelete">Excluir</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal retonar preço original -->
        <div class="modal fade" id="returnOriginalPrice" tabindex="-1" role="dialog" aria-labelledby="deleteModal" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row text-white">
                  <div class="col-12 d-flex justify-content-end mb-3">
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="col-8 pb-2 pt-1 pl-3">
                    <label class="form-control-label h4">Deseja Retonar ao Preço Original?</label>
                  </div>
                  <div class="col-4 text-right">
                    <button type="button" class="btn btn-outline-danger" @click="confirmReturnOriginalPrice">Confirmar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal filtrar produto -->
        <div class="modal fade" id="filterModal" tabindex="-1" role="dialog" aria-labelledby="filterModal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Filtros de produto</h5>
                <button type="button" class="btn actions-btn d-flex justify-content-center align-items-center" data-dismiss="modal" aria-label="Close">
                  <img :src="require('@/assets/images/icon_close-x.svg')" alt="Ícone de Fechar">
                </button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-4">
                      <label class="fs-16 no-margin">Produto:</label>
                      <div v-for="filter in availableFilters" :key="filter.value" class="d-flex align-items-center gap-8">
                        <input type="checkbox" :value="filter.value" :checked="isChecked(filter.value)" @change="toggleFilter(filter.value)" class="checkbox-wh cursor-pointer" />
                        <label class="fs-16 no-margin">{{ filter.label }}</label>
                      </div>
                    </div>
                    <div class="col-4">
                      <label class="fs-16 no-margin">Tipo de produto:</label>
                      <select v-model="filters.type" class="form-control cursor-pointer">
                        <option :value="null">Selecione</option>
                        <option :value="1">Produto Simples</option>
                        <option :value="2">Produto com Variações</option>
                        <option :value="3">Kit Simples</option>
                        <option :value="4">Kit com Variações</option>
                        <option :value="5">Digital</option>
                      </select>
                    </div>
                    <div class="col-4">
                      <label class="fs-16 no-margin">Categoria do produto:</label>
                      <select v-model="filters.category" class="form-control cursor-pointer">
                        <option :value="null">Selecione</option>
                        <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button @click="clearFilters" type="button" class="btn actions-btn d-flex justify-content-center align-items-center mobile-responsive-limpar-filtro gap-8 text-black">
                  Limpar filtro
                </button>
                <button @click="applyFilters" type="button" class="button-w-100 btn btn-success px-32">
                  Filtrar
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import LoadingComponent from '../../components/layout/LoadingComponent'
import PaginateComponent from '../../components/PaginateComponent'

export default {

  name: 'IndexProductsPage',

  components: {
    LoadingComponent,
    PaginateComponent
  },

  data: function () {
    return {
      product_id: null,
      selectedProducts: [],
      selectAll: false,
      showPricePanel: false,
      showLinkCategoryPanel: false,
      showLinkMaterialPanel: false,
      showLinkColorPanel: false,
      showFilterPanel: false,
      search: '',
      applyAdjustment: false,
      applyAdjustmentSelectProduct: {},
      adjustmentValue: 0,
      applyAllCategory: false,
      selectedGlobalCategory: '',
      selectedGlobalMaterial: '',
      selectedGlobalColor: '',
      isUp: false,
      lastUsedFilters: {},
      selectedFilters: [],
      product: {
        price: ''
      },
      formattedPrice: '',
      availableFilters: [
        { label: 'Ativo', value: 1, type: 'status' },
        { label: 'Inativo', value: 0, type: 'status' },
        { label: 'Com estoque', value: 'in_stock', type: 'stock' },
        { label: 'Sem estoque', value: 'out_of_stock', type: 'stock' }
      ],
      filters: {
        category: null,
        type: null,
        name: '',
        status: [],
        stock: []
      },
      selectedCategories: {},
      priceEdits: {},
      sortBy: null, // Coluna atual de ordenação
      sortOrder: 'asc' // 'asc' = crescente, 'desc' = decrescente
    }
  },

  computed: mapState({
    products: state => state.products.data || [],
    categories: state => state.params.data.categories,
    materials: state => state.params.data.materials,
    colors: state => state.params.data.colors,
    pagination: state => state.products.pagination,
    loading: state => state.products.loading,
    allSelected: state => state.selectedProducts === state.products.data,
    someSelected: state => state.selectedProducts.length > 0 && !state.allSelected,
    selectedProducts: state => state.selectedProducts || [],
    productDetails: state => state.products.details,
    currentProduct () {
      return this.productDetails.id === this.$route.params.id
        ? this.productDetails
        : {}
    },
    sortedProducts () {
      if (!this.sortBy || !this.sortOrder) {
        return this.products // Retorna a lista original quando não há ordenação
      }

      return [...this.products].sort((a, b) => {
        const modifier = this.sortOrder === 'asc' ? 1 : -1

        const valueA = typeof a[this.sortBy] === 'string' ? a[this.sortBy].toLowerCase() : a[this.sortBy]
        const valueB = typeof b[this.sortBy] === 'string' ? b[this.sortBy].toLowerCase() : b[this.sortBy]

        if (valueA < valueB) return -1 * modifier
        if (valueA > valueB) return 1 * modifier
        return 0
      })
    }
  }),

  methods: {

    ...mapActions('products', [
      'index',
      'store',
      'show',
      'update',
      'updateCategories',
      'resetPrices',
      'destroy',
      'searchProductsWithPaginate'
    ]),

    ...mapActions('params', ['getCategories', 'getMaterials', 'getColors']),

    async saveAll () {
      try {
        const invalidIds = this.selectedProducts.filter(id =>
          !this.products.some(product => product.id === id)
        )
        if (invalidIds.length > 0) {
          this.$toasted.error(`IDs inválidos encontrados: ${invalidIds.join(', ')}`)
          return
        }

        if (this.showPricePanel) {
          this.selectedProducts.forEach(productId => {
            this.applyPercentageAdjustment(productId)
          })

          const data = this.selectedProducts.map(productId => {
            const update = { product_id: productId, saleprice: parseFloat(this.priceEdits[productId].raw) || 0 }
            return update
          })

          await this.$store.dispatch('products/updatePrice', data)
        } else if (this.showLinkCategoryPanel) {
          const data = this.selectedProducts.map(productId => {
            const update = { product_id: productId, company_category_id: this.selectedGlobalCategory }
            return update
          })

          await this.$store.dispatch('products/updateCategories', { data })
        } else if (this.showLinkMaterialPanel) {
          const data = this.selectedProducts.map(productId => {
            const update = { product_id: productId, param_material_id: this.selectedGlobalMaterial }
            return update
          })

          await this.$store.dispatch('products/updateMaterials', { data })
        } else if (this.showLinkColorPanel) {
          const data = this.selectedProducts.map(productId => {
            const update = { product_id: productId, param_color_id: this.selectedGlobalColor }
            return update
          })

          await this.$store.dispatch('products/updateColors', { data })
        }

        this.resetSelections()
      } catch (error) {
        console.warn('Erro ao salvar os produtos:', error)
      }
    },

    openReturnOriginalPriceModal (ids) {
      // this.product_id = Array.isArray(ids) ? ids : [ids]
      $('#returnOriginalPrice').modal('show')
    },

    async confirmReturnOriginalPrice () {
      await this.$store.dispatch('products/resetPrices', this.selectedProducts)
      await this.resetSelections()
    },

    resetSelections () {
      this.selectedProducts = []
      this.selectedCategories = {}
      this.selectedGlobalCategory = ''
      this.showPricePanel = false
      this.showLinkCategoryPanel = false
    },

    selectCategory (productId, category) {
      this.$set(this.selectedCategories, productId, category.id)
    },

    changeCategory (response) {
      if (response) {
        this.data.category_id = response.category_id
        this.data.categories = response.categories_title
      }
    },

    addCategory (productId, category) {
      if (!category) return

      if (this.applyAllCategory) {
        this.selectedGlobalCategory = category.id
        this.selectedProducts.forEach(id => {
          this.$set(this.selectedCategories, id, category.id)
        })
      } else {
        console.log('caiu aqui 2 -', productId, '-', category)
        this.$set(this.selectedCategories, productId, category)
      }
    },

    openDeleteModal (ids) {
      this.product_id = Array.isArray(ids) ? ids : [ids]
      $('#deleteModal').modal('show')
    },

    confirmDelete () {
      this.destroy(this.product_id)
        .then(() => {
          this.selectedProducts = []
          $('#deleteModal').modal('hide')
        })
        .catch(() => {})
    },

    openFilterModal: function () {
      $('#filterModal').modal('show')
    },

    toggleFilter (value) {
      const foundFilter = this.availableFilters.find(f => f.value === value)
      const filterType = foundFilter ? foundFilter.type : undefined

      if (!filterType) return

      const index = this.filters[filterType].indexOf(value)
      if (index === -1) {
        this.filters[filterType].push(value) // Adiciona se não existir
      } else {
        this.filters[filterType].splice(index, 1) // Remove se já estiver presente
      }
    },

    toggleAdjustment () {
      this.applyAdjustment = !this.applyAdjustment

      if (!this.applyAdjustment) {
        this.adjustmentValue = 0
        this.selectedProducts.forEach(productId => {
          const original = this.priceEdits[productId].original
          this.$set(this.priceEdits[productId], 'raw', original.toFixed(2))
          this.$set(this.priceEdits[productId], 'formatted', this.formatCurrency(original))
        })
      }

      this.selectedProducts.forEach(productId => {
        this.$set(this.applyAdjustmentSelectProduct, productId, this.applyAdjustment)
      })

      if (this.applyAdjustment) {
        this.selectedProducts.forEach(productId => {
          this.applyPercentageAdjustment(productId)
        })
      }
    },

    isChecked (value) {
      const filterType = this.availableFilters.find(f => f.value === value)?.type
      return this.filters[filterType]?.includes(value)
    },

    closePopupAndClearSelection () {
      this.selectedProducts = []
      this.showPopup = false
    },

    clearFilters () {
      this.filters = {
        category: null,
        type: null,
        name: '',
        status: [],
        stock: []
      }
      this.applyFilters()
      $('#filterModal').modal('hide')
    },

    closePopUpFilter () {
      this.showFilterPanel = false
    },

    handleSearch () {
      this.lastUsedFilters = {
        search_title: this.search,
        status: this.selectedFilters.includes('active') && this.selectedFilters.includes('inactive')
          ? [1, 0]
          : this.selectedFilters.includes('active')
            ? 1
            : this.selectedFilters.includes('inactive')
              ? 0
              : null,
        stock: this.selectedFilters.includes('in_stock') ? 'in_stock' : this.selectedFilters.includes('out_of_stock') ? 'out_of_stock' : null,
        sort_by: this.filters.sortBy,
        order_by: this.filters.orderBy
      }

      const query = Object.fromEntries(
        Object.entries(this.lastUsedFilters).filter(([key, value]) => value !== null && value !== '')
      )

      this.$store.dispatch('products/index', {
        page: 1,
        filters: query
      })
    },

    async applyFilters () {
      const filters = {
        category: this.filters.category || null,
        type: this.filters.type || null,
        name: this.filters.name || '',
        status: this.filters.status.length ? this.filters.status : [],
        stock: this.filters.stock.length ? this.filters.stock : []
      }

      await this.$store.dispatch('products/index', { page: 1, filters })
      $('#filterModal').modal('hide')
    },

    sortTable (column) {
      // Se clicar em uma nova coluna, resetar para 'asc'
      if (this.sortBy !== column) {
        this.sortBy = column
        this.sortOrder = 'asc'
      } else if (this.sortOrder === 'asc') {
        this.sortOrder = 'desc'
      } else if (this.sortOrder === 'desc') {
        this.sortOrder = null
        this.sortBy = null
      } else {
        this.sortOrder = 'asc'
      }
    },

    formatPrice (productId, event) {
      const value = event.target.value.replace(/\D/g, '')
      let rawValue = '0.00'

      if (value) rawValue = (parseInt(value, 10) / 100).toFixed(2)

      this.$set(this.priceEdits[productId], 'raw', rawValue)
      this.$set(this.priceEdits[productId], 'formatted', this.formatCurrency(rawValue))
    },

    formatCurrency (value) {
      let numericValue = parseFloat(value)
      if (isNaN(numericValue)) {
        numericValue = 0.0
      }
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      })
        .format(numericValue)
        .replace('R$', '')
        .trim()
    },

    applyPercentageAdjustment (productId) {
      const product = this.products.find(p => p.id === productId)
      if (!product) return

      const originalPrice = parseFloat(product.price).toFixed(4)
      const percentage = this.adjustmentValue / 100

      let newPrice = originalPrice

      if (this.adjustmentValue > 0) {
        if (this.isUp) {
          newPrice = (originalPrice * (1 + percentage)).toFixed(4)
        } else {
          newPrice = (originalPrice * (1 - percentage)).toFixed(4)
        }
      }

      this.$set(this.priceEdits[productId], 'raw', parseFloat(newPrice).toFixed(2))
      this.$set(this.priceEdits[productId], 'formatted', this.formatCurrency(newPrice))
    },

    toggleSelectAll () {
      if (this.selectAll) {
        this.selectedProducts = this.products.map(product => product.id)
        this.showFilterPanel = false
        this.showPricePanel = false
        this.showLinkCategoryPanel = false
      } else {
        this.selectedProducts = []
      }

      this.$nextTick(() => {
        if (this.$refs.selectAllCheckbox) {
          this.$refs.selectAllCheckbox.indeterminate = false
        }
      })
    },

    togglePricePanel () {
      this.showFilterPanel = false
      this.showLinkCategoryPanel = false
      this.showLinkMaterialPanel = false
      this.showLinkColorPanel = false
      this.showPricePanel = !this.showPricePanel

      if (!this.showPricePanel && this.selectedProducts.length === 0) this.showFilterPanel = true
    },

    toggleLinkCategoryPanel () {
      this.showFilterPanel = false
      this.showPricePanel = false
      this.showLinkMaterialPanel = false
      this.showLinkColorPanel = false
      this.showLinkCategoryPanel = !this.showLinkCategoryPanel

      if (!this.showLinkCategoryPanel && this.selectedProducts.length === 0) this.showFilterPanel = true
    },

    toggleLinkMaterialPanel () {
      this.showFilterPanel = false
      this.showPricePanel = false
      this.showLinkCategoryPanel = false
      this.showLinkColorPanel = false
      this.showLinkMaterialPanel = !this.showLinkMaterialPanel

      if (!this.showLinkMaterialPanel && this.selectedProducts.length === 0) this.showFilterPanel = true
    },

    toggleLinkColorPanel () {
      this.showFilterPanel = false
      this.showPricePanel = false
      this.showLinkCategoryPanel = false
      this.showLinkMaterialPanel = false
      this.showLinkColorPanel = !this.showLinkColorPanel
      if (!this.showLinkColorPanel && this.selectedProducts.length === 0) this.showFilterPanel = true
    },

    toggleFilterPanel () {
      this.selectedProducts = []
      this.showPricePanel = false
      this.showLinkCategoryPanel = false
      this.showLinkMaterialPanel = false
      this.showLinkColorPanel = false
      this.showFilterPanel = true
    },

    handleCheckboxChange () {
      if (this.selectedProducts.length > 0) {
        this.showFilterPanel = false
      } else {
        if ((!this.showPricePanel && !this.showLinkCategoryPanel) || this.selectedProducts.length === 0) {
          this.showFilterPanel = true
        }
      }
    },

    handleAdjustmentInput (event) {
      const value = event.target.value === '' ? 0 : Math.min(100, Math.max(0, parseInt(event.target.value) || 0))
      this.adjustmentValue = value
      if (this.applyAdjustment) {
        this.selectedProducts.forEach(productId => {
          this.applyPercentageAdjustment(productId)
        })
      }
    },

    handleAdjustmentBlur (event) {
      if (event.target.value === '') {
        this.adjustmentValue = 0
        if (this.applyAdjustment) {
          this.selectedProducts.forEach(productId => {
            this.applyPercentageAdjustment(productId)
          })
        }
      }
    },

    updateAdjustmentValue (event) {
      const value = parseInt(event.target.innerText, 10)
      if (!isNaN(value)) {
        this.adjustmentValue = Math.min(100, Math.max(1, value))
      } else {
        event.target.innerText = this.adjustmentValue
      }
    },

    enableAdjustment (productId) {
      this.$set(this.applyAdjustmentSelectProduct, productId, true)
    },

    disableAdjustment (productId) {
      this.$set(this.applyAdjustmentSelectProduct, productId, false)
      const hasActiveAdjustment = this.selectedProducts.some(id =>
        this.applyAdjustmentSelectProduct[id]
      )
      if (!hasActiveAdjustment) this.applyAdjustment = false
    },

    toggleIcon () {
      this.isUp = !this.isUp
    },

    navigate (page) {
      this.$store.dispatch('products/index', {
        page,
        filters: this.filters
      })
    },

    loadProduct () {
      this.$store.dispatch('products/show', this.$route.params.id)
        .then(product => {
          if (!product?.id) this.$router.push('/not-found')
        })
        .catch(error => {
          this.$toasted.error('Falha ao carregar produto', error)
          this.$router.push('/products')
        })
    }
  },

  watch: {
    selectedProducts: {
      handler (newVal) {
        newVal.forEach(productId => {
          if (!this.priceEdits[productId]) {
            const product = this.products.find(p => p.id === productId)
            if (product) {
              this.$set(this.priceEdits, productId, {
                formatted: this.formatCurrency(product.price),
                raw: product.price.toString(),
                original: parseFloat(product.price)
              })
            }
          }
        })

        Object.keys(this.priceEdits).forEach(productId => {
          if (!newVal.includes(parseInt(productId))) {
            this.$delete(this.priceEdits, productId)
          }
        })
      },
      immediate: true
    },

    applyAdjustment (newVal) {
      if (!newVal) this.adjustmentValue = 0
    },

    adjustmentValue (newVal) {
      if (this.applyAdjustment) {
        this.selectedProducts.forEach(productId => {
          this.applyPercentageAdjustment(productId)
        })
      }
    },

    isUp () {
      if (this.applyAdjustment) {
        this.selectedProducts.forEach(productId => {
          this.applyPercentageAdjustment(productId)
        })
      }
    }
  },

  mounted () {
    this.index({
      page: 1,
      filters: null
    }).then(() => {
      this.products.forEach(product => {
        this.$set(this.priceEdits, product.id, {
          formatted: this.formatCurrency(product.price),
          raw: product.price.toString()
        })
      })
    })
    this.getCategories({ page: 1 })
    this.getMaterials({ page: 1 })
    this.getColors({ page: 1 })
    this.handleSearch()
  }
}
</script>
